export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const SET_ITEM_QUANTITY = 'SET_ITEM_QUANTITY';
export const INCREMENT_ITEM_QUANTITY = 'INCREMENT_ITEM_QUANTITY';
export const DECREMENT_ITEM_QUANTITY = 'DECREMENT_ITEM_QUANTITY';
export const CLEAR_ITEMS = 'CLEAR_ITEMS';
export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';